// main.js - Vite entry point. Pulls every module into the bundle so its IIFE
// runs and its DOMContentLoaded listeners register. Vite walks the import
// graph from here; nothing else needs to be wired in index.html.

import './css/style.css';

// Before anything renders: if this build is a Netlify preview rather than the
// real app, say so across the top of the page.
import './preview-build.js';

import './config.js';
import './utils.js';
import './ui.js';
import './auth.js';
import './db.js';
import './evaluation-data.js';
import './selection-data.js';

import './dictation.js';
import './draft.js';
import './import.js';

import './calibration.js';
import './evaluation.js';
import './evaluation-planner.js';
import './code-generator.js';

// dashboard, the pdf-* stack and the selection screens are intentionally NOT
// imported here. app.js loads them lazily (see lazy-screen.js), so Vite builds
// them into their own chunks that stay out of the main bundle and are fetched
// on first use. Their IIFEs run on first import instead of at boot.

import './app.js';

// Error capture - must come after AUTH + UI are loaded but before any user
// interaction starts.
import { ERRORS } from './errors.js';
ERRORS.init();

// Service worker registration is handled by vite-plugin-pwa (registerType:
// 'autoUpdate' in vite.config.js) - no manual navigator.serviceWorker.register
// call needed here.
